<div fxLayout="column">
    <div class="user-profile-container" *ngIf="!(isAdv|async) && !(isRep|async)" fxLayout="row" fxLayoutAlign="center">
        <div fxFlex="40" fxFlex.lt-md="100">
            <lib-change-user-profile (profileChange)="onProfile($event)"
                                     (infoMsg)="onInfoOccurred($event)"
                                     (errorMsg)="onErrorOccurred($event)">
            </lib-change-user-profile>
        </div>
    </div>
    <div *ngIf="!(isAdv|async) && !(isRep|async)" fxLayout="row" fxLayoutAlign="center">
        <div fxLayout="column" fxLayoutGap="12px" fxFlex="20" fxFlex.lt-md="100" class="info-panel">
            <div class="txt-h-20-7">{{ 'Legal information'|i18n }}:</div>
            <div fxLayout="row">
                <a href="javascript:void(0);" rel="noopener noreferrer" (click)="openECDocLink(cookiePolicyLink)">
                    {{ 'Cookie Policy'|i18n }}
                </a>
            </div>
            <div fxLayout="row">
                <a href="javascript:void(0);" rel="noopener noreferrer" (click)="openECDocLink(privacyPolicyLink)">
                    {{ 'Privacy Policy__{profile}'|i18n }}
                </a>
            </div>
            <div fxLayout="row">
                <a href="javascript:void(0);" rel="noopener noreferrer" (click)="openECDocLink(termsAndConditionsLink)">
                    {{ 'Terms and Conditions'|i18n }}
                </a>
            </div>
            <div fxLayout="row">
                <a href="javascript:void(0);" rel="noopener noreferrer" (click)="openECDocLink(specificClausesLink)">
                    {{ 'Clauses__{profile}'|i18n }}
                </a>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isAdv|async" class="user-profile-container" fxFlex="100" fxLayout="row wrap" fxLayout.lt-sm="column wrap"
     fxLayoutAlign="start start" fxLayoutAlign.lt-sm="start center">
    <ng-container>
        <mat-card class="profile-card nested-card">
            <mat-card-title>
                <span class="txt-h-18-7">{{ 'Your data'|i18n }}</span>
            </mat-card-title>
            <mat-card-content fxLayout="column" fxLayoutGap="20px">
                <div fxLayout="column" fxLayoutGap="12px" class="pod-panel">
                    <div fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="txt-h-16-7">{{ 'Biographical data'|i18n }}:</span>
                    </div>
                    <ng-container *ngIf="subjectInfo">
                        <div fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'Juridical type'|i18n }}:</span>
                            <span>{{ subjectInfo.subject.juridical_type|ecMemberJuridicalType|i18n }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="5px" *ngIf="subjectInfo.subject.legal_form">
                            <span class="field-name">{{ 'Legal form'|i18n }}:</span>
                            <span>{{ subjectInfo.subject.legal_form|ecMemberLegalFormType|i18n }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="5px" *ngIf="subjectInfo.subject.subject_type">
                            <span class="field-name">{{ 'Subject type'|i18n }}:</span>
                            <span>{{ subjectInfo.subject.subject_type|ecMemberSubjectType|i18n }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="5px" *ngIf="subjectInfo.subject.entity_subtype">
                            <span class="field-name">{{ 'Entity subtype'|i18n }}:</span>
                            <span>{{ subjectInfo.subject.entity_subtype|ecMemberEntitySubtype|i18n }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">
                                {{ (subjectInfo.subject.juridical_type === ECJuridicalType.CORPORATE_ENTITY ? 'Signatory\'s first name' : 'First name')|i18n }}:
                            </span>
                            <span>{{ subjectInfo.subject.personal_data.first_name }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ (subjectInfo.subject.juridical_type === ECJuridicalType.CORPORATE_ENTITY ? 'Signatory\'s last name' : 'Last name')|i18n }}:</span>
                            <span>{{ subjectInfo.subject.personal_data.last_name }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.company_name as company_name" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'Company name'|i18n }}:</span>
                            <span>{{ company_name }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.mobile_number as mobile" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'Mobile'|i18n }}:</span>
                            <span>{{ mobile }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.telephone_number as telephone"
                             fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'Telephone'|i18n }}:</span>
                            <span>{{ telephone }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'Email'|i18n }}:</span>
                            <span>{{ subjectInfo.subject.personal_data.email }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.pec as pec" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'PEC'|i18n }}:</span>
                            <span>{{ pec }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.piva as piva" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'P. iva'|i18n }}:</span>
                            <span>{{ piva }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.cf as cf" fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'CF'|i18n }}:</span>
                            <span>{{ cf }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.iban as iban" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'IBAN'|i18n }}:</span>
                            <span>{{ iban }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.address as address" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">
                                {{(!(subjectInfo.subject.juridical_type === ECJuridicalType.INDIVIDUAL && subjectInfo.subject.legal_form === ECLegalForm.OTHER_INDIVIDUALS) ?
                                'Registered office address' : 'Residential address')|i18n}}:
                            </span>
                            <span>{{ addressToString(address) }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.birth_date" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ (subjectInfo.subject.juridical_type === ECJuridicalType.CORPORATE_ENTITY ? 'Signatory\'s birth date' : 'Birth date')|i18n }}:</span>
                            <span>{{ subjectInfo.subject.personal_data.birth_date|i18nDate }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.birth_country" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ (subjectInfo.subject.juridical_type === ECJuridicalType.CORPORATE_ENTITY ?  'Signatory\'s birth country' : 'Birth country')|i18n }}:</span>
                            <span>{{ subjectInfo.subject.personal_data.birth_country }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.birth_municipality" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ (subjectInfo.subject.juridical_type === ECJuridicalType.CORPORATE_ENTITY ?  'Signatory\'s birth municipality' : 'Birth municipality')|i18n }}:</span>
                            <span>{{ subjectInfo.subject.personal_data.birth_municipality }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.personal_data?.ateco_code" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'ATECO code'|i18n }}:</span>
                            <span>{{ subjectInfo.subject.personal_data.ateco_code }}</span>
                        </div>
                        <div *ngIf="subjectInfo.subject.signatory_tax_code" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{'Signatory\'s tax code'|i18n}}:</span>
                            <span>{{ subjectInfo.subject.signatory_tax_code }}</span>
                        </div>
                        <div *ngIf="profile" fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'Username'|i18n }}:</span>
                            <span>{{ profile.username }}</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!subjectInfo && showError">
                        <span app-error>{{ 'Cannot retrieve subject data'|i18n }}.</span>
                    </ng-container>
                    <div fxLayout="row" fxLayoutAlign="center" class="mt-10 mb-10">
                        <button app-primary-button type="submit" (click)="changePasswordNavigate($event)">
                            {{ 'Change password'|i18n }}
                        </button>
                    </div>
                </div>

                <div fxLayout="column" fxLayoutGap="12px" class="pod-panel">
                    <div fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="txt-h-16-7">{{ 'Legal information'|i18n }}:</span>
                    </div>
                    <div fxLayout="row wrap" fxLayoutGap="5px">
                        <a href="javascript:void(0);" rel="noopener noreferrer"
                           (click)="openECDocLink(cookiePolicyLink)">
                            {{ 'Cookie Policy'|i18n }}
                        </a>
                    </div>
                    <div fxLayout="row wrap" fxLayoutGap="5px">
                        <a href="javascript:void(0);" rel="noopener noreferrer"
                           (click)="privacyPolicyDocumentId ?
                           openECDocId(privacyPolicyDocumentId) :
                           openECDocLink(privacyPolicyLink)">
                            {{ 'Privacy Policy__{profile}'|i18n }}
                        </a>
                    </div>
                    <div fxLayout="row wrap" fxLayoutGap="5px">
                        <a href="javascript:void(0);" rel="noopener noreferrer"
                           (click)="openECDocLink(termsAndConditionsLink)">
                            {{ 'Terms and Conditions'|i18n }}
                        </a>
                    </div>
                    <div fxLayout="row wrap" fxLayoutGap="5px">
                        <a href="javascript:void(0);" rel="noopener noreferrer"
                           (click)="openECDocLink(specificClausesLink)">
                            {{ 'Clauses__{profile}'|i18n }}
                        </a>
                    </div>
                </div>

                <div fxLayout="column" fxLayoutGap="12px" class="pod-panel"
                     *ngIf="subjectInfo && subjectInfo.subject.documents.length > 0">
                    <div fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="txt-h-16-7">{{ 'Documents'|i18n }}:</span>
                    </div>
                    <div *ngFor="let doc of subjectInfo.subject.documents" class="gap" fxLayout="row wrap"
                         fxLayoutAlign="space-between center" fxLayoutGap="12px">
                        <div fxLayout="row wrap" fxLayoutGap="4px">
                            <span class="field-name">{{ doc.document_type|ecDocumentTypeI18n }}:</span>
                            <span>{{ doc.filename || '--'|i18n }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="4px">
                            <span class="size-mb">{{ prettySize(doc.size) }}</span>
                            <button *ngIf="hasFile(doc)" app-small-ghost-button
                                    (click)="onClickDownloadMemberDocument(doc)">
                                <app-icon name="fal-file"></app-icon>
                                {{ 'Open file'|i18n }}
                            </button>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="profile-card nested-card">
            <mat-card-title>
                <span class="txt-h-18-7">{{ 'Your utilities'|i18n }}</span>
            </mat-card-title>
            <mat-card-content fxLayout="column" fxLayoutGap="20px">
                <ng-container *ngIf="subjectInfo">
                    <div *ngFor="let pod of subjectInfo.subject.pods; let i=index">
                        <mat-accordion class="p-none pod-panel">
                            <mat-expansion-panel class="expansion-panel">
                                <mat-expansion-panel-header>
                                    <div *appVar="isPodActive(pod)|async as podActive" class="header"
                                         fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="50px">
                                        <div fxLayout="row wrap">
                                            <div class="mr-10" fxLayout="row" fxLayoutGap="4px">
                                                <span class="field-name">{{ 'POD {0}'|i18n:(i + 1) }}:</span>
                                                <span>{{ pod.pod }}</span>
                                            </div>
                                            <div *ngIf="podActive" class="active-pod">
                                                <app-icon name="fal-check-circle"></app-icon>
                                                {{ 'Active to this day'|i18n }}
                                            </div>
                                            <div *ngIf="!podActive" class="inactive-pod">
                                                <app-icon name="fal-times-circle"></app-icon>
                                                {{ 'Not active to this day'|i18n }}
                                            </div>
                                        </div>
                                        <div class="ml-auto" fxLayout="row" fxLayoutGap="4px">
                                            <button (click)="navigateToEntity(pod.pod)" app-small-ghost-button>
                                                <app-icon name="fal-sitemap"></app-icon>
                                                <app-icon name="fal-arrow-right" class="no-margin"></app-icon>
                                            </button>
                                        </div>
                                    </div>
                                </mat-expansion-panel-header>
                                <div fxLayout="column" fxLayoutGap="12px">
                                    <div *ngIf="pod.resource" class="ml-16" fxLayout="row wrap" fxLayoutGap="4px">
                                        <div class="field-name">{{ 'Energy profile'|i18n }}:</div>
                                        <div> {{getLabeledProfile(pod.resource)|i18n}}</div>
                                    </div>
                                    <div *ngIf="pod.pod_utility_type" class="ml-16" fxLayout="row wrap"
                                         fxLayoutGap="8px">
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                            <span class="field-name">{{ 'Type of utility'|i18n }}:</span>
                                            <span>{{ (pod.pod_utility_type|genericPipe)|i18n }}</span>
                                        </div>
                                        <div *ngIf="pod.aspiring_prosumer" class="aspiring-prosumer" fxLayout="row"
                                             fxLayoutAlign="space-between center" fxLayoutGap="8px">
                                            <app-icon name="fal-telescope"></app-icon>
                                            <span class="aspiring-text">{{ 'Aspiring prosumer'|i18n }}</span>
                                        </div>
                                    </div>
                                    <div *ngIf="pod.address?.postal_code" class="ml-16" fxLayout="row wrap"
                                         fxLayoutGap="4px">
                                        <span class="field-name">{{ 'Address'|i18n }}:</span>
                                        <span>{{ addressToString(pod.address)|i18n }}</span>
                                    </div>
                                    <div *ngIf="pod.has_wifi" class="ml-16" fxLayout="row wrap" fxLayoutGap="4px">
                                        <span class="field-name">{{ 'Wi-Fi'|i18n }}:</span>
                                        <span>{{ (pod.has_wifi ? 'Yes' : 'No')|i18n }}</span>
                                    </div>
                                    <div *ngIf="pod.energy_provider" class="ml-16" fxLayout="row wrap"
                                         fxLayoutGap="4px">
                                        <span class="field-name">{{ 'Energy supplier'|i18n }}:</span>
                                        <span>{{ pod.energy_provider|i18n }}</span>
                                    </div>
                                    <div *ngIf="isDefined(pod.effective_date)" class="ml-16" fxLayout="row wrap"
                                         fxLayoutGap="4px">
                                        <span class="field-name">{{ 'Activation date'|i18n }}:</span>
                                        <span>{{ pod.effective_date|i18nDate }}</span>
                                    </div>
                                    <div *ngIf="isDefined(pod.deactivation_date)" class="ml-16" fxLayout="row wrap"
                                         fxLayoutGap="4px">
                                        <span class="field-name">{{ 'Deactivation date'|i18n }}:</span>
                                        <span>{{ pod.deactivation_date|i18nDate }}</span>
                                    </div>
                                    <div class="ml-16" fxLayout="row wrap" fxLayoutGap="4px">
                                        <span class="field-name">{{ 'Monitored by smart meter'|i18n }}:</span>
                                        <div class="txt-p-14-4" *ngIf="monitoredPod(pod.resource)">
                                            <app-icon name="fal-check-circle" class="mr-10 monitored"></app-icon>
                                            {{ pod.resource.pod.meter_model ? (pod.resource.pod.meter_model|meterModel) : ('Undefined'|i18n) }}
                                        </div>
                                        <div class="txt-p-14-4" *ngIf="!monitoredPod(pod.resource)">
                                            <app-icon name="fal-times-circle"></app-icon>
                                        </div>
                                    </div>
                                    <div *ngIf="pod.land_registry_data?.section" class="ml-16" fxLayout="row wrap" fxLayoutGap="4px">
                                        <span class="field-name">{{'Land registry section'|i18n}}:</span>
                                        <span>{{pod.land_registry_data.section}}</span>
                                    </div>
                                    <div *ngIf="pod.land_registry_data?.sheet" class="ml-16" fxLayout="row wrap" fxLayoutGap="4px">
                                        <span class="field-name">{{'Land registry sheet'|i18n}}:</span>
                                        <span>{{pod.land_registry_data.sheet}}</span>
                                    </div>
                                    <div *ngIf="pod.land_registry_data?.particle" class="ml-16" fxLayout="row wrap" fxLayoutGap="4px">
                                        <span class="field-name">{{'Land registry particle'|i18n}}:</span>
                                        <span>{{pod.land_registry_data.particle}}</span>
                                    </div>
                                    <div *ngIf="pod.land_registry_data?.subdivision" class="ml-16" fxLayout="row wrap" fxLayoutGap="4px">
                                        <span class="field-name">{{'Land registry subdivision'|i18n}}:</span>
                                        <span>{{pod.land_registry_data.subdivision}}</span>
                                    </div>
                                    <ng-container *ngIf="pod.resource && pod.resource.plants.length > 0">
                                        <hr class="divider">
                                        <ng-container *ngFor="let plant of pod.resource.plants; let i = index">
                                            <div class="mr-10 mt-10" fxLayout="row wrap">
                                                <span class="field-name">{{ 'Plant {0}'|i18n:(i + 1) }}:</span>
                                            </div>
                                            <div class="ml-16" fxLayout="row wrap" fxLayoutGap="5px">
                                                <span class="field-name">{{ 'Name'|i18n }}:</span>
                                                <span>{{ plant.name }}</span>
                                            </div>
                                            <div class="ml-16" fxLayout="row wrap" fxLayoutGap="5px">
                                                <span class="field-name">{{ 'Nominal power'|i18n }}:</span>
                                                <span>{{ plant.plant.nominal_power|niceValue:'kW':2 }}</span>
                                            </div>
                                            <div *ngIf="plant.plant.production_pod" class="ml-16" fxLayout="row wrap"
                                                 fxLayoutGap="5px">
                                                <span class="field-name">{{ 'Production POD'|i18n }}:</span>
                                                <span>{{ plant.plant.production_pod }}</span>
                                            </div>
                                            <div *ngIf="isDefined(plant.plant.activation_date)" class="ml-16"
                                                 fxLayout="row wrap" fxLayoutGap="4px">
                                                <span class="field-name">{{ 'Activation date'|i18n }}:</span>
                                                <span>{{ plant.plant.activation_date|i18nDate }}</span>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </ng-container>
                <ng-container *ngIf="!subjectInfo && showError">
                    <span app-error>{{ 'Cannot retrieve subject utilities'|i18n }}.</span>
                </ng-container>
            </mat-card-content>
        </mat-card>

        <mat-card *ngIf="eCRepresentativePersonalData || documentsWithoutPrivacy.length > 0"
                  class="profile-card nested-card">
            <mat-card-title>
                <span class="txt-h-18-7">{{ 'Your community'|i18n }}</span>
            </mat-card-title>
            <mat-card-content fxLayout="column" fxLayoutGap="20px">
                <div fxLayout="column" fxLayoutGap="12px" class="pod-panel" *ngIf="eCRepresentativePersonalData">
                    <div fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="txt-h-16-7">{{ 'Your representative'|i18n }}:</span>
                    </div>
                    <div *ngIf="eCRepresentativePersonalData.first_name" fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="field-name">{{ 'Name'|i18n }}:</span>
                        <span>{{ eCRepresentativePersonalData.first_name }}</span>
                    </div>
                    <div *ngIf="eCRepresentativePersonalData.last_name" fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="field-name">{{ 'Surname'|i18n }}:</span>
                        <span>{{ eCRepresentativePersonalData.last_name }}</span>
                    </div>
                    <div *ngIf="eCRepresentativePersonalData.company_name" fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="field-name">{{ 'Company name'|i18n }}:</span>
                        <span>{{ eCRepresentativePersonalData.company_name }}</span>
                    </div>
                    <div *ngIf="eCRepresentativePersonalData.email" fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="field-name">{{ 'Email'|i18n }}:</span>
                        <span>{{ eCRepresentativePersonalData.email }}</span>
                    </div>
                    <div *ngIf="eCRepresentativePersonalData.mobile_number" fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="field-name">{{ 'Mobile'|i18n }}:</span>
                        <span>{{ eCRepresentativePersonalData.mobile_number }}</span>
                    </div>
                </div>
                <div *ngIf="!eCRepresentativePersonalData && showError">
                    <span app-error>{{ 'Cannot retrieve representative data'|i18n }}.</span>
                </div>
                <div fxLayout="column" fxLayoutGap="12px" class="pod-panel" *ngIf="documentsWithoutPrivacy.length > 0">
                    <div fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="txt-h-16-7">{{ 'Documents'|i18n }}:</span>
                    </div>
                    <div *ngFor="let doc of documentsWithoutPrivacy" class="gap" fxLayout="row wrap"
                         fxLayoutAlign="space-between center" fxLayoutGap="12px">
                        <div fxLayout="row wrap" fxLayoutGap="4px">
                            <span class="field-name">{{ doc.document_type|ecDocumentTypeI18n }}:</span>
                            <span>{{ doc.filename || '--'|i18n }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="4px">
                            <span class="size-mb">{{ prettySize(doc.size) }}</span>
                            <button *ngIf="hasFile(doc)" app-small-ghost-button
                                    (click)="onClickDownloadCommunityDocument(doc)">
                                <app-icon name="fal-file"></app-icon>
                                {{ 'Open file'|i18n }}
                            </button>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </ng-container>
</div>

<div *ngIf="isRep|async" class="user-profile-container" fxFlex="100" fxLayout="row wrap" fxLayout.lt-sm="column wrap"
     fxLayoutAlign="center center" fxLayoutAlign.lt-sm="center center">
    <ng-container>
        <mat-card class="profile-card nested-card">
            <mat-card-title>
                <span class="txt-h-18-7">{{ 'Your data'|i18n }}</span>
            </mat-card-title>
            <mat-card-content fxLayout="column" fxLayoutGap="20px">
                <div fxLayout="column" fxLayoutGap="12px" class="pod-panel">
                    <div fxLayout="row wrap" fxLayoutGap="5px">
                        <span class="txt-h-16-7">{{ 'Biographical data'|i18n }}:</span>
                    </div>
                    <ng-container *ngIf="representativeData">
                        <div fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'Subject type'|i18n }}:</span>
                            <span>{{ representativeData.representative_type|ecRepresentativeType|i18n }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'Name'|i18n }}:</span>
                            <span>{{ representativeData.personal_data?.first_name }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'Surname'|i18n }}:</span>
                            <span>{{ representativeData.personal_data?.last_name }}</span>
                        </div>
                        <div *ngIf="representativeData.personal_data?.company_name as company_name" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'Company name'|i18n }}:</span>
                            <span>{{ company_name }}</span>
                        </div>
                        <div *ngIf="representativeData.personal_data?.mobile_number as mobile" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'Mobile'|i18n }}:</span>
                            <span>{{ mobile }}</span>
                        </div>
                        <div *ngIf="representativeData.personal_data?.telephone_number as telephone"
                             fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'Telephone'|i18n }}:</span>
                            <span>{{ telephone }}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'Email'|i18n }}:</span>
                            <span>{{ representativeData.personal_data?.email }}</span>
                        </div>
                        <div *ngIf="representativeData.personal_data?.pec as pec" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'PEC'|i18n }}:</span>
                            <span>{{ pec }}</span>
                        </div>
                        <div *ngIf="representativeData.personal_data?.piva as piva" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'P. iva'|i18n }}:</span>
                            <span>{{ piva }}</span>
                        </div>
                        <div *ngIf="representativeData.personal_data?.cf as cf" fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'CF'|i18n }}:</span>
                            <span>{{ cf }}</span>
                        </div>
                        <div *ngIf="representativeData.personal_data?.address as address" fxLayout="row wrap"
                             fxLayoutGap="5px">
                            <span class="field-name">{{ 'Address'|i18n }}:</span>
                            <span>{{ addressToString(address) }}</span>
                        </div>
                        <div *ngIf="profile" fxLayout="row wrap" fxLayoutGap="5px">
                            <span class="field-name">{{ 'Username'|i18n }}:</span>
                            <span>{{ profile.username }}</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!representativeData && showError">
                        <span app-error>{{ 'Cannot retrieve subject data'|i18n }}.</span>
                    </ng-container>
                    <div fxLayout="row" fxLayoutAlign="center" class="mt-10 mb-10">
                        <button app-primary-button type="submit" (click)="changePasswordNavigate($event)">
                            {{ 'Change password'|i18n }}
                        </button>
                    </div>
                </div>

            </mat-card-content>
        </mat-card>

    </ng-container>
</div>
